{
  "ChangeLayoutOptionTitle": "Clique para ver as opções de layout do painel.",
  "NAME": "ChangeLayout"
}